import React from "react";
import "./restricted_access.css";

const RestrictedAccess = () => (
	<div className="restricted-access-container">
		<div>
			<h1 className="restricted-access-container__title">Access Forbidden</h1>
			<p className="restricted-access-container__message">You are not allowed to access this resource</p>
		</div>
	</div>
);

export default RestrictedAccess;
